import axios from "axios"
import { API_BASE_URL } from "./api.config"

export class BufferService {
    constructor(name) {
    this.url = API_BASE_URL.endsWith('/')
      ? API_BASE_URL
      : API_BASE_URL + '/'

    this.entityName = name
  }

    async get() {
        const lists = await axios.get(this.url + this.entityName)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return lists
    }

    async getList() {
        const lists = await axios.get(this.url + this.entityName + "/list")
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return lists
    }

    async getId(id) {
        const lists = await axios.get(this.url + this.entityName + '/' + id)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return lists
    }

    async options(isView) {
        const metadata = await axios.options( this.url + this.entityName + '/' + 
            (localStorage.getItem('lng') ? localStorage.getItem('lng') : 'pt') + (isView ? '?isView=true' : ''))
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return metadata
    }

    async post(data) {
        const res = await axios.post(this.url + this.entityName, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }
    async postPath(path,data) {
        const res = await axios.post(this.url + this.entityName + path, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async postId(id, data) {
        const lists = await axios.post(this.url + this.entityName + '/' + id, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return lists
    }

    async postQuery(data) {
        const res = await axios.post(this.url + this.entityName + data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async delete(id) {
        const res = await axios.delete(this.url + this.entityName + '/' + id)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async putQuery(query, data) {
        const res = await axios.put(this.url + this.entityName + query, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async put(data) {
        const res = await axios.put(this.url + this.entityName, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async update(id, data) {
        const res = await axios.put(this.url + this.entityName + '/' + id, data)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return res
    }

    async filter(filter) {
        const filterList = await axios.get(this.url + this.entityName + filter)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                return error
            })
        return filterList
    }
}